/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
enum ServiceType {
  TRAINING = 'Training',
  WELLNESS = 'Wellness',
}

export default ServiceType;
